/*
  Texte SEO Kloody : le texte est replié sur quelques lignes avec un bouton « Lire la suite »
  (nombre de lignes réglable, une valeur pour mobile et une pour ordinateur).
  Le texte complet reste dans le HTML (rien n'est masqué par display:none) ; sans JavaScript, tout est affiché.
  Le repli n'existe que si le texte dépasse réellement le nombre de lignes, et sur ordinateur seulement
  si le réglage « Replier aussi sur ordinateur » est coché.
*/
if (!customElements.get('kl-seo-text')) {
  class KlSeoText extends HTMLElement {
    connectedCallback() {
      this._body = this.querySelector('[data-seo-body]');
      this._button = this.querySelector('[data-seo-toggle]');
      this._label = this.querySelector('[data-seo-toggle-label]');
      if (!this._body || !this._button) return;

      this._mq = window.matchMedia('(max-width: 749.98px)');
      this._onChange = () => this._measure();
      this._onClick = () => this._toggle();
      this._button.addEventListener('click', this._onClick);
      this._mq.addEventListener('change', this._onChange);
      window.addEventListener('resize', this._onChange);
      // Les polices peuvent changer la hauteur du texte : on mesure à nouveau quand elles sont prêtes
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this._onChange);
      this._measure();
    }

    disconnectedCallback() {
      if (this._button) this._button.removeEventListener('click', this._onClick);
      if (this._mq) this._mq.removeEventListener('change', this._onChange);
      window.removeEventListener('resize', this._onChange);
    }

    _measure() {
      if (!this._mq.matches && this.dataset.desktopCollapse === 'false') {
        this._setState(false, false);
        return;
      }
      // Mesure avec le repli appliqué : le texte dépasse-t-il le nombre de lignes réglé ?
      const wasExpanded = this._button.getAttribute('aria-expanded') === 'true';
      this.classList.add('is-collapsible', 'is-collapsed');
      const overflows = this._body.scrollHeight > this._body.clientHeight + 1;
      if (!overflows) {
        this._setState(false, false);
      } else {
        this._setState(true, !wasExpanded);
      }
    }

    _setState(collapsible, collapsed) {
      this.classList.toggle('is-collapsible', collapsible);
      this.classList.toggle('is-collapsed', collapsible && collapsed);
      this._button.hidden = !collapsible;
      this._button.setAttribute('aria-expanded', collapsible && !collapsed ? 'true' : 'false');
      if (this._label) {
        this._label.textContent = collapsed ? this._button.dataset.more : this._button.dataset.less;
      }
    }

    _toggle() {
      const expanded = this._button.getAttribute('aria-expanded') === 'true';
      this._setState(true, expanded);
    }
  }

  customElements.define('kl-seo-text', KlSeoText);
}
